var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M1.333 8.586V7.413A1.27 1.27 0 0 1 2.6 6.146c1.206 0 1.7-.853 1.093-1.9-.347-.6-.14-1.38.467-1.726l1.153-.66a1.113 1.113 0 0 1 1.52.4l.073.126c.6 1.047 1.587 1.047 2.194 0l.073-.126a1.113 1.113 0 0 1 1.52-.4l1.153.66c.607.346.814 1.126.467 1.726-.607 1.047-.113 1.9 1.093 1.9a1.27 1.27 0 0 1 1.267 1.267v1.173a1.27 1.27 0 0 1-1.267 1.267c-1.206 0-1.7.853-1.093 1.9.347.607.14 1.38-.467 1.727l-1.153.66a1.113 1.113 0 0 1-1.52-.4l-.073-.127c-.6-1.047-1.587-1.047-2.194 0l-.073.127a1.113 1.113 0 0 1-1.52.4l-1.153-.66a1.266 1.266 0 0 1-.467-1.727c.607-1.047.113-1.9-1.093-1.9a1.27 1.27 0 0 1-1.267-1.267Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting2);
export default __webpack_public_path__ + "static/media/setting-2.caec58a0bf0d65df4dbb5a83f2f9fe74.svg";
export { ForwardRef as ReactComponent };